// The engagement module's entire public surface (ADR-0016).
//
// Three exports and one stylesheet. Nothing outside this folder may import from
// any other file in it, and nothing in this folder imports from `pages/` or
// `components/` — which is what makes removing the module a matter of deleting
// the folder and the three lines in App.tsx that reference it.

import "./engagement.css";

export { EngagementProvider } from "./EngagementContext";
export { Engagement } from "./Engagement";
export { CoachToolbarButton } from "./CoachToolbarButton";
export { StartRedirect } from "./StartRedirect";

/** Where every sign-in lands. Kept here so callers never hardcode the path. */
export const START_ROUTE = "/start";
